import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import TrackingProvider from "@/components/TrackingProvider";
import { CartProvider } from "@/components/CartContext";
import CartDrawer from "@/components/CartDrawer";
import LandingPage from "@/pages/LandingPage";
import ThankYouPage from "@/pages/ThankYouPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import ClarityProtocolPage from "@/pages/ClarityProtocolPage";
import ExitIntentPage from "@/pages/ExitIntentPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import RecoveryPage from "@/pages/RecoveryPage";
import MediaKitPage from "@/pages/MediaKitPage";
import StorePage from "@/pages/StorePage";
import ScienceArticle from "@/pages/ScienceArticle";
import ScienceIndex from "@/pages/ScienceIndex";
import BookClubKitPage from "@/pages/BookClubKitPage";

function App() {
  return (
    <div className="font-body">
      <CartProvider>
        <BrowserRouter>
          <TrackingProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/store" element={<StorePage />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
              <Route path="/confirmation" element={<ConfirmationPage />} />
              <Route path="/clarity-protocol" element={<ClarityProtocolPage />} />
              <Route path="/exit-intent" element={<ExitIntentPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/recovery" element={<RecoveryPage />} />
              <Route path="/media-kit" element={<MediaKitPage />} />
              <Route path="/science" element={<ScienceIndex />} />
              <Route path="/science/:slug" element={<ScienceArticle />} />
              <Route path="/book-club-kit" element={<BookClubKitPage />} />
            </Routes>
            <CartDrawer />
          </TrackingProvider>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </CartProvider>
    </div>
  );
}

export default App;
